/**
 * @class Event Bus class, used to send events between all controllers
 */
//module.exports = function () {
function EventBus() {
  window.vent = this;
  /**
   * List of current topics
   */
  var topics = {};

  // /**
  //  * Subscribe an event listener to a given topic. If the topic does not exist, it will be created.
  //  * @param {String} topic Topic name
  //  * @param {Object} eventListener Listener to subscribe to the topic
  //  * @param {function} eventListener.notify Function to be called when an event is published (event is first argument).
  //  */
  // this.subscribe = function (topic, eventListener) {
  //   if (topics.hasOwnProperty(topic)) {
  //     topics[topic].push(eventListener);
  //   } else {
  //     topics[topic] = [eventListener];
  //   }
  //   return {
  //     remove: function () {
  //       // Add a timeout to put this at the end of the queue
  //       // Prevent exception when iterate over listeners and one of them would unsubscribe
  //       setTimeout(function () {
  //         topics[topic].splice(topics[topic].indexOf(eventListener), 1);
  //       }, 0);
  //     }
  //   };
  // };

  this.on = function (topic, callback) {
    var eventListener = {
      notify: callback
    };
    if (topics.hasOwnProperty(topic)) {
      topics[topic].push(eventListener);
    } else {
      topics[topic] = [eventListener];
    }
    return {
      remove: function remove() {
        // Add a timeout to put this at the end of the queue
        // Prevent exception when iterate over listeners and one of them would unsubscribe
        setTimeout(function () {
          topics[topic].splice(topics[topic].indexOf(eventListener), 1);
        }, 0);
      }
    };
  };

  /**
   * Publish an event to a given topic (call <code>notify(event)</code> on each listeners)
   * @param {String} topic Topic name
   * @param {Object} event Custom event object (first argument of <code>notify()</code> function)
   */
  this.publish = function (topic, event) {
    if (topics.hasOwnProperty(topic)) {
      for (var i in topics[topic]) {
        var eventListener = topics[topic][i];
        if (eventListener.hasOwnProperty('notify')) {
          try {
            eventListener.notify(event);
          } catch (error) {
            console.error('[event-bus]', error);
            throw error;
          }
        } else {
          console.error('[event-bus]', "Invalid listener for topic '" + topic + "'.");
        }
      }
    }
  };
}
module.exports = new EventBus();